import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  postApiIdentityUsers,
  postApiIdentityUsersSave,
  postApiIdentityUsersSync,
} from "@/lib/api/generated/identity/identity";
import type {
  DirectoryUsersResponse,
  SyncUsersResponse,
  User,
} from "@/lib/api/generated/control-api.schemas";
import { queryKeys } from "./keys";
import type { TenantAppUserRoleKey } from "../../../../../packages/shared-types/src/tenant-app-user-roles.js";

export function useTenantDirectoryUsersQuery(tenantId: string) {
  return useQuery({
    queryKey: queryKeys.tenantDirectoryUsers(tenantId),
    queryFn: async () =>
      (await postApiIdentityUsers({
        tenantId,
        page: 1,
        pageSize: 100,
      })) as DirectoryUsersResponse,
    enabled: Boolean(tenantId),
  });
}

export function useSaveTenantAppUserMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: {
      tenantId: string;
      userId: string;
      phone?: string;
      roleKeys: TenantAppUserRoleKey[];
    }) =>
      (await postApiIdentityUsersSave(input)) as User,
    onSuccess: (_data, input) => {
      qc.invalidateQueries({ queryKey: queryKeys.tenantDirectoryUsers(input.tenantId) });
    },
  });
}

export function useSyncTenantDirectoryUsersMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { tenantId: string }) =>
      (await postApiIdentityUsersSync({ tenantId: input.tenantId })) as SyncUsersResponse,
    onSuccess: (_data, input) => {
      qc.invalidateQueries({ queryKey: queryKeys.tenantDirectoryUsers(input.tenantId) });
    },
  });
}
